import { getLocale } from '../dataImplementation/viewingRegionWeb'
import {
  getVirginGroupNews,
  getCompanies,
  getTimeline,
  getAboutVirginLatest,
  getVirginUniteLatest,
  getBooks,
  getVirginUniteWebsite,
  getVirginUnite,
  getBeingAVirginBusiness,
  getOurApproach,
  getSeniorTeam,
  getVirginGroup,
  getSpendVirginPoints,
  getEarnVirginPoints,
  getMyRedRewards,
  getRedHome,
  getVirginGroupCareers,
  getAboutVirgin,
  getBransonFamilyHome,
  getOurStory,
} from './urls'
import { PUBLIC_URL } from '../config'

export interface Link {
  href: string
  label: string
  children: Link[]
  parent?: Link
}

export interface Tier1Link extends Link {
  backgroundImageUrl: string
  altLabel?: string
  backgroudImageAlt?: string
}

const homeLink: Tier1Link = {
  href: '/',
  label: 'Home',
  children: [],
  backgroundImageUrl: `${PUBLIC_URL}/img/topnavbar/menu/open-menu-home-and-default.jpg`,
  backgroudImageAlt: 'Virgin logo',
}

const links: Tier1Link[] = [
  homeLink,
  {
    href: getCompanies().as,
    label: 'Companies',
    children: [],
    backgroundImageUrl: `${PUBLIC_URL}/img/topnavbar/menu/open-menu-companies.jpg`,
    backgroudImageAlt: 'Virgin company logos',
  },
  {
    href: getAboutVirgin().as,
    label: 'About Us',
    children: [
      {
        href: getOurStory().as,
        label: 'Our Story',
        children: [],
      },
      {
        href: getTimeline().as,
        label: 'Timeline',
        children: [],
      },
      {
        href: getVirginGroupCareers().as,
        label: 'Working at Virgin',
        children: [],
      },
      {
        href: getAboutVirginLatest().as,
        label: 'Latest',
        children: [],
      },
      {
        href: getVirginGroup().as,
        label: 'Virgin Group',
        children: [
          {
            href: getOurApproach().as,
            label: 'Our Approach',
            children: [],
          },
          {
            href: getBeingAVirginBusiness().as,
            label: 'Being A Virgin Business',
            children: [],
          },
          {
            href: getSeniorTeam().as,
            label: 'Senior Team',
            children: [],
          },
          {
            href: getVirginGroupNews().as,
            label: 'News',
            children: [],
          },
        ],
      },
    ],
    backgroundImageUrl: `${PUBLIC_URL}/img/topnavbar/menu/open-menu-about-us.png`,
    backgroudImageAlt: 'Virgin Voyages dancers',
  },

  {
    href: getVirginUnite().as,
    label: 'Our Foundation',
    children: [
      {
        href: getVirginUniteLatest().as,
        label: 'Latest',
        children: [],
      },
      {
        href: getVirginUniteWebsite().as,
        label: 'Virgin Unite website',
        children: [],
      },
    ],
    backgroundImageUrl: `${PUBLIC_URL}/img/topnavbar/menu/open-menu-richard-unite.jpg`,
    backgroudImageAlt: 'Richard Branson marching in a crowd at an Elders event',
  },
  {
    href: getBransonFamilyHome().as,
    label: 'Branson Family',
    children: [
      {
        href: '/branson-family/richard-branson-blog',
        label: 'Richard’s Blog',
        children: [],
      },
      {
        href: '/branson-family/holly-branson-blog',
        label: 'Holly’s Blog',
        children: [],
      },
      {
        href: getBooks().as,
        label: 'Books',
        children: [],
      },
      {
        href: '/branson-family/book-a-branson',
        label: 'Book a Branson',
        children: [],
      },
    ],
    backgroundImageUrl: `${PUBLIC_URL}/img/topnavbar/menu/open-menu-branson-family.png`,
    backgroudImageAlt: 'Holly, Richard and Sam Branson at Virgin Stars of the Year 2019 event',
  },
  {
    href: getRedHome().as,
    label: 'Virgin Red',
    altLabel: 'Home',
    children: [
      {
        href: getSpendVirginPoints().as,
        label: 'Spend',
        children: [],
      },
      {
        href: getEarnVirginPoints().as,
        label: 'Earn',
        children: [],
      },
      {
        href: getMyRedRewards().as,
        label: 'My Rewards',
        children: [],
      },
    ],
    backgroundImageUrl: '',
    backgroudImageAlt: '',
  },
]

function setParentOfChildren(link: Link): void {
  link.children.forEach((child) => {
    child.parent = link
    setParentOfChildren(child)
  })
}
links.forEach(setParentOfChildren)

function getActive(currentPath: string, links: Link[]): Link | null {
  for (let i = 0; i < links.length; i++) {
    const link = links[i]
    if (link.href === currentPath) {
      return link
    }
    const activeLink = getActive(currentPath, link.children)
    if (activeLink) {
      return activeLink
    }
  }

  return null
}

export function getActiveTier1(currentPath: string): Tier1Link | null {
  const tier1Segment = currentPath.split('/')[1]
  if (tier1Segment === '') {
    return null
  }
  for (let i = 0; i < links.length; i++) {
    const link = links[i]
    if (link.href === '/' + tier1Segment) {
      return link
    }
    // Keep Virgin Red submenu upon when viewing a regionalized site
    if (link.href === '/virgin-red' && tier1Segment === getLocale()) {
      return link
    }
  }

  return null
}

export function getActiveTier2(currentPath: string): Link | null {
  const tier1Link = getActiveTier1(currentPath)
  const tieredSegments = currentPath.split('/').slice(1, 3)
  if (tier1Link === null) {
    return null
  } else {
    for (let i = 0; i < tier1Link.children.length; i++) {
      const link = tier1Link.children[i]
      if (link.href === '/' + tieredSegments.join('/')) {
        return link
      }
    }
  }

  return null
}

export function getActiveTier3(currentPath: string): Link | null {
  const tier2Link = getActiveTier2(currentPath)
  const tieredSegments = currentPath.split('/').slice(1, 4)
  if (tier2Link === null) {
    return null
  } else {
    for (let i = 0; i < tier2Link.children.length; i++) {
      const link = tier2Link.children[i]
      if (link.href === '/' + tieredSegments.join('/')) {
        return link
      }
    }
  }

  return null
}

export function getActiveLink(currentPath: string): Link | null {
  return getActive(currentPath, links)
}

function closestActiveAncestorLink(segments: string[], links: Link[], level: number): Link | null {
  let testUrl = ''
  for (let i = 0; i < level; i++) {
    testUrl += '/' + segments[i]
  }

  for (let i = 0; i < links.length; i++) {
    const link = links[i]
    if (link.href === testUrl) {
      const match = closestActiveAncestorLink(segments, link.children, level + 1)
      if (match) {
        return match
      }
      return link
    }
  }

  return null
}

/**
 *
 * @param currentPath current url e.g. /branson-family/richard-branson
 */
export function getActiveLinkOrClosestAncestor(currentPath: string): Link {
  const segments = currentPath.split('/').filter((s) => s)
  const closest = closestActiveAncestorLink(segments, links, 1)
  return closest || homeLink
}

export function getEnabledLinks(): Tier1Link[] {
  return links
}

export const linkActive = (href: string, children: Link[], currentPath: string): boolean => {
  const isActivePage = (href: string): boolean => (href === currentPath ? true : currentPath.startsWith(href + '/'))
  const isActive = isActivePage(href)
  if (isActive) {
    return true
  }

  if (!children) {
    return false
  }

  return !!children.find((child) => isActivePage(child.href))
}
